import * as Yup from 'yup';
import phoneNumber from '../../schemas/phoneNumber';

export default Yup.object().shape({
  name: Yup.string()
    .min(2, 'Nome troppo corto')
    .required('Il nome è necessario'),
  address: Yup.string()
    .required('L\'indirizzo immobile è necessario'),
  phoneNumber: Yup.string()
    .required('Il recapito telefonico è necessario')
    .concat(phoneNumber),
  email: Yup.string()
    .email('Formato email non valido'),
  consent: Yup.boolean()
    .oneOf([true], 'Il consenso è necessario'),
});
